
import React, { useState } from "react";
import { Editor } from "@tiptap/react";
import HeadingSelect from "./HeadingSelect";

// Import our toolbar section components
import TextFormatTools from "./toolbar/TextFormatTools";
import AlignmentTools from "./toolbar/AlignmentTools";
import MediaTools from "./toolbar/MediaTools";
import HistoryTools from "./toolbar/HistoryTools";
import LinkTool from "./toolbar/LinkTool";
import CodeTool from "./toolbar/CodeTool";
import MediaDialogs from "./toolbar/MediaDialogs";

interface EditorToolbarProps {
  editor: Editor;
  uploadImage?: (file: File) => Promise<string>;
}

const EditorToolbar = ({ editor, uploadImage }: EditorToolbarProps) => {
  // State management for popovers and dialogs
  const [linkPopoverOpen, setLinkPopoverOpen] = useState(false);
  const [imagePopoverOpen, setImagePopoverOpen] = useState(false);
  const [videoPopoverOpen, setVideoPopoverOpen] = useState(false);
  const [galleryPopoverOpen, setGalleryPopoverOpen] = useState(false);
  const [mediaLibraryOpen, setMediaLibraryOpen] = useState(false);

  const handleMediaSelect = (url: string) => {
    // Insert the selected media as an image
    if (url) {
      editor.chain().focus().setImage({ src: url }).run();
    }
    setMediaLibraryOpen(false);
  };

  const handleImageClick = () => {
    console.log("Image button clicked");
    setImagePopoverOpen(true);
  };

  const handleVideoClick = () => {
    console.log("Video button clicked");
    setVideoPopoverOpen(true);
  };

  return (
    <div className="flex flex-wrap gap-1 p-2 border-b bg-muted/20">
      <HeadingSelect editor={editor} />
      
      <div className="h-8 w-px bg-border mx-1" />
      
      {/* Text formatting tools */}
      <TextFormatTools editor={editor} />
      
      {/* Alignment tools */}
      <AlignmentTools editor={editor} />
      
      {/* Code tool */}
      <CodeTool editor={editor} />
      
      {/* Link tool */}
      <LinkTool 
        editor={editor} 
        linkPopoverOpen={linkPopoverOpen} 
        setLinkPopoverOpen={setLinkPopoverOpen} 
      />
      
      {/* Media tools */}
      <MediaTools 
        editor={editor}
        onImageButtonClick={handleImageClick}
        onVideoButtonClick={handleVideoClick}
        onGalleryButtonClick={() => setGalleryPopoverOpen(true)}
        onMediaLibraryButtonClick={() => setMediaLibraryOpen(true)}
      />
      
      {/* History tools */}
      <HistoryTools editor={editor} />
      
      {/* Media dialogs */}
      <MediaDialogs 
        editor={editor}
        uploadImage={uploadImage}
        imagePopoverOpen={imagePopoverOpen}
        setImagePopoverOpen={setImagePopoverOpen}
        videoPopoverOpen={videoPopoverOpen}
        setVideoPopoverOpen={setVideoPopoverOpen}
        galleryPopoverOpen={galleryPopoverOpen}
        setGalleryPopoverOpen={setGalleryPopoverOpen}
        mediaLibraryOpen={mediaLibraryOpen}
        setMediaLibraryOpen={setMediaLibraryOpen}
        handleMediaSelect={handleMediaSelect}
      />
    </div>
  );
};

export default EditorToolbar;
